import { ProductCatalogItemProps } from "../Components/ProductCatalogItem";
import { getData } from "./general/httpDataService";

export const getProductCatalogItems = (): Promise<ProductCatalogItemProps[]> => {
    return getData<ProductCatalogItemProps[]>("/assets/producten20220225.json");
}   